
jQuery(function($){
	/**
	 * Set cookieBar variables and run function
	 *
	 * https://github.com/kovarp/jquery.cookieBar
	 */
	
	/**
	 * Run functions
	 */
	blockSlider();
	rwdMenu();
    inifFancybox();
	goTo();;
	contactUs();
	siteMenu();
	apartamentsFilter();
	apartamentsMore();
	contactFormMore();

	function contactFormMore() {
		$(".show-more-rodo").click(function(event) {
      event.preventDefault();
      var rodo = $(this).attr('href');
      $(rodo).slideToggle(400);
  
      // Zmiana tekstu odnośnika
      if ($(this).text() === 'ROZWIŃ') {
          $(this).text('ZWIŃ');
      } else {
          $(this).text('ROZWIŃ');
      }
    });
	}

	function apartamentsMore() {
		$(".show-more").click(function(event) {
			event.preventDefault();
			$(this).parent('td').parent('tr').children('.description').slideToggle(300);
			$(this).toggleClass('active');
		});
	}

	function apartamentsFilter() {

		// Obsługa zmiany wartości suwaka
		$('#slider-range').on('slidechange', function (e, ui) {
			e.preventDefault();
			updateFilters();
		});
	
		// Obsługa zmiany wartości elementów <select>
		$('#rooms, #floor, #status').on('change', function () {
			updateFilters();
		});
	
		// Funkcja do aktualizacji filtrów i wywołania żądania AJAX
		function updateFilters() {
			var type = $('#type').val();
			var rooms = $('#rooms').val();
			var floor = $('#floor').val();
			var status = $('#status').is(':checked');
			var status_go = status ? 'free' : 'all';
			
			var price_min = $('#price_min').val();
			var price_max = $('#price_max').val();
			var typ = $('#typ').val();
			var data = {
				action: 'apartaments_filter',
				type: type,
				typ: typ,
				rooms: rooms,
				floor: floor,
				status: status_go,
				price_min: price_min,
				price_max: price_max,
			};
	
			$.ajax({
				url: '/wp-admin/admin-ajax.php',
				data: data,
				method: 'POST',
				success: function (data) {
				  
					data = JSON.parse(data);
					console.log(data);
					if ('tiles' == type) {
						$('.flats-tiles').html(data);
					} else {
						$('.flats-list').html(data);
					}
				},
				cache: false
			});
		}
	}

	function contactUs() {
		var singlePage = $('.single-flat__header').length;

		if(singlePage == 1) {
			var houseName = $('.contact-us').attr('data-name');
			jQuery('#kontakt textarea').val(houseName+'. ');
		}
		$('.contact-us').click(function(event) {
			event.preventDefault();
			var houseName = $(this).attr('data-name');

			jQuery('#kontakt textarea').val(houseName+'. ')
		});
	}

	function siteMenu() {
		var window_width = jQuery(window).width();
		
		jQuery(".home .internal a").click(function(event) {
		  event.preventDefault(); 
		
		  var href = jQuery(this).attr('href');
		  var href = href.substring(1, href.length);
		  if(href == '#kontakt') {
			var pos = 100;
		  } else {
			var pos = 100;
		  }
		  
		
		  jQuery('html, body').animate({
		  scrollTop: jQuery(href).offset().top - pos
		  }, 200);
		
		  jQuery('body').addClass('clicked');
		  if (window_width < 768) {
		  jQuery('#hamburger').removeClass('open');
		  jQuery('.site-header__navigation > ul').slideUp(400);
		  jQuery('header').removeClass('menu-opened');
		  }
		});
	  }
	

	function goTo() {

		$(".go-to").click(function(event) {
			event.preventDefault();
			var href = $(this).attr('href');
			var pos = -100;
			jQuery('html, body').animate({
				scrollTop: jQuery(href).offset().top + pos
				}, 500);
		});
	  }

	


  function inifFancybox() {
    Fancybox.bind('[data-fancybox]', {
      Thumbs: false,
		  loop : true,

      afterClose: function(instance, current) {
        var videos = document.querySelectorAll('.inline-movies');

        // Loop through all videos with class 'inline-movies' and pause them
        videos.forEach(function(video) {
            video.pause();
        });
      }
		});
	  }
    
	function rwdMenu() {
		var windowWidth = $(document).width();

		$('#hamburger').click(function(event) {
			event.preventDefault();
			$(this).toggleClass('open');
			$('.site-header__navigation > ul').slideToggle(500);
			$('.site-header').toggleClass('menu-opened');
		});
	}

	(function () {
		var previousScroll = 0;
		
		$(window).scroll(function () {
			
			
			   var currentScroll = $(this).scrollTop();

			   if (currentScroll > 80) {
				   if (currentScroll > previousScroll){
					   $('header').addClass('fixed');
				   }
				   else {
					  $('header').removeClass('fixed');
				   }
				   previousScroll = currentScroll;
			   } else {
					   $('header').removeClass('fixed');
					$('header').removeClass('fixed');
			   }
	 });
		}());
        $(window).scroll(function() {   
            var windowWidth = $(window).width();
            var scroll = $(window).scrollTop();
    
            if (scroll >= 250 ) {
                $("header").addClass("scrolled");
           
            } else {
                $("header").removeClass("scrolled");
            }
    
        });

	function blockSlider() {
		

		

		jQuery('.header-slider').owlCarousel({
			loop:true,
			margin:0,
			nav:true,
			items:1,
			autoplay:true,
			autoplayTimeout:4000,
			autoplaySpeed: 1700,
			slideSpeed: 1700,
			navSpeed: 1700,
			dotsSpeed: 1700,
			dots: false,
			singleItem: true,
			navText: ['<svg width="30" height="56" viewBox="0 0 30 56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26.9805 3.5L2.98047 28L26.9805 52.5" stroke="white" stroke-width="4" stroke-linecap="square"/></svg>','<svg width="30" height="56" viewBox="0 0 30 56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.98047 52.5L26.9805 28L2.98047 3.5" stroke="white" stroke-width="4" stroke-linecap="square"/></svg>'],
			autoplayHoverPause:true
		});

		jQuery('.gallery-slider').owlCarousel({
			loop:true,
			margin:0,
			nav:true,
			items:1,
			autoplay:false,
			autoplayTimeout:4000,
			autoplaySpeed: 1700,
			slideSpeed: 1700,
			navSpeed: 1700,
			dotsSpeed: 1700,
			dots: true,
			singleItem: true,
			navText: ['<svg width="30" height="56" viewBox="0 0 30 56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26.9805 3.5L2.98047 28L26.9805 52.5" stroke="white" stroke-width="4" stroke-linecap="square"/></svg>','<svg width="30" height="56" viewBox="0 0 30 56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.98047 52.5L26.9805 28L2.98047 3.5" stroke="white" stroke-width="4" stroke-linecap="square"/></svg>'],
			autoplayHoverPause:true
		});


		  jQuery('.testimonials-slider').owlCarousel({
			loop:true,
			margin:20,
			nav:true,
			items:1,
			autoplay:false,
			autoplayTimeout:4000,
			autoplaySpeed: 1700,
			slideSpeed: 1700,
			navSpeed: 1700,
			dotsSpeed: 1700,
			dots: false,
			singleItem: true,
			navText: ["<svg width='177' height='102' viewBox='0 0 177 102' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M176.5 51.0483H2M2 51.0483L52.0483 1M2 51.0483L52.0483 101.097' stroke='#4F4740' stroke-width='2'/></svg>","<svg width='176' height='102' viewBox='0 0 176 102' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M-0.00390625 51.0483H174.496M174.496 51.0483L124.448 1M174.496 51.0483L124.448 101.097' stroke='#4F4740' stroke-width='2'/></svg>"],
				autoplayHoverPause:true,
				responsive:{
				  0:{
					items:1,
				  },
				  960:{
					items:2,
				  },
				  1100:{
					items:3,
				  },
				  1240:{
					items:4,
				  },
				  1440:{
					  items:5,
					},
				  1900:{
					  items:6,
					},
				  
				}
		  });
      
	 }

})